<template>
  <div class="activity-content">
    <page-template
      ref="deposit"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    >
    </page-template>
  </div>
</template>

<script>
import api from "@/config/api";
import pageTemplate from "@/components/template/pageTemplate";
import userPower from "@/mixin/userPower";

export default {
  mixins: [userPower],
  components: { pageTemplate},
  data() {
    return {
      page: {
        current: 1,
        total: 0,
        pageSize: 10
      },
      activitySearchOptions:{
        simple: [
          {
            label: '',
            prop: 'activityName',
            type: 'input',
            span: 8,
            placeholder:'请输入单号'
          },
        ],
        complex: [
          {
            label: '选择日期',
            prop: 'CreateDttm',
            type: 'datetimeRange',
            dateType: 'datetime',
            span: 24
          },
          {
            label: "活动类型",
            prop: "cardStoreId",
            type: "select",
            span: 24,
            data:[{name:'全部',value:''},{name:'线上',value:'1'},{name:'线下',value:'2'}],
          },
        ],
      },
      searchOptions: {
        simple: [
          {
            label: '',
            prop: 'activityName',
            type: 'input',
            span: 8,
            placeholder:'请输入活动名称'
          },
        ],
        complex: [
          {
            label: "选择日期",
            prop: "CreateDttm",
            type: "dateTimeRangeButton",
            dateType: "datetime",
            span: 24,
          },
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            span: 8,
            isHasAll: true,
            data: [],
            url: api.system.seStore,
            // defaultValue:this.$utils.getSysUser().storeId?this.$utils.getSysUser().storeId:-1
          },
          // {
          //   label: "活动门店",
          //   prop: "memberCategoryId",
          //   type: "select",
          //   span: 6,
          //   data: [],
          //   url: api.store.storeList,
          // },
          {
            label: "活动类型",
            prop: "activityType",
            type: "select",
            span: 6,
            data:[{name:'全部',value:''},{name:'限时特价',value:10},{name:'限时折扣',value:20},{name:'满减活动',value:30},{name:'满折活动',value:40},],
            // url:api.store.storeList
          },
          {
            label: "活动状态",
            prop: "status",
            type: "select",
            span: 6,
            data:[{name:'全部',value:''},{name:'未开始',value:10},{name:'进行中',value:20},{name:'已终止',value:40},{name:'已结束',value:30}],
            // url:api.store.storeList
          },
        ],
      },
      toolConfig:[
        {
          name: '详情',
          code: 'details',
          type: this.$utils.buttonType.tableOperate,
          callback: this.openDialog
        }
      ],
      tableOptions: {
        indexShow: true, //是否显示索引
        columns: [
          {
            label: "活动门店",
            prop: "storeName",
            align: "center",
            width:"120"
          },
          {
            label: "活动名称",
            prop: "activityName",
            align: "center",
            width:"120"
          },
          {
            label: "活动类型",
            prop: "activityType",
            align: "center",
            width:"120",
            enumData: this.$utils.getCacheStatus('mkActivity.activityType'),
          },
          {
            label: "成交订单数",
            prop: "orderCount",
            align: "center",
            width:"90"
          },
          {
            label: "优惠总金额",
            prop: "discountPrice",
            align: "center",
            width:"90"
          },
          {
            label: "实收总金额",
            prop: "amountReceived",
            align: "center",
            width:"90"
          },
          {
            label: "开始时间",
            prop: "startTime",
            align: "center",
            width:"100",
          },
          {
            label: "结束时间",
            prop: "endTime",
            align: "center",
            width:"100",
          },
          {
            label: "活动状态",
            prop: "status",
            align: "center",
            width:"80",
            enumData: this.$utils.getCacheStatus('mkActivity.status'),
          },
        ],
        // url: api.promotion.activityStatistics
      },
      // 活动详情列表
      detailTableOptions: {
        disabled: false,
        indexShow: true, //是否显示索引
        columns: [
          {
            label: '单号',
            prop: 'tradeNo',
            width: '100',
          },
          {
            label: '会员手机号',
            prop: 'payType',
            width: '100',
          },
          {
            label: '参与渠道',
            prop: 'payPrice',
            width: '100',
          },
          {
            label: '活动商品支付金额',
            prop: 'createDttm',
            width: '100',
          },
          {
            label: '折扣金额',
            prop: 'createDttm',
            width: '100',
          },
          {
            label: '支付时间',
            prop: 'createDttm',
            width: '100',
          },
        ],
        url: api.promotion.activityStatistics
      },
    };
  },
  created() {
    this.setStoreId(this.searchOptions.complex);
  },
  mounted() {
    this.$refs["deposit"].$refs["searchFormTemp"].complexFunc()
    this.tableOptions.url = api.promotion.activityStatistics
    this.$refs['deposit'].$refs['searchFormTemp'].submitForm()
  },
  methods: {
    openDialog(row){
      this.$router.push({path:'/activity/detail',query:{activityId:row.activityId}})
    },
    // 搜索重置
    searchClear() {
      // this.$refs.goodsSync.simpleClear()
      this.searchParam = {};
      this.getTableData({});
    },
    //搜索查询
    searchSubmit(param) {

    },
    // 详情列表数据
    getTableData(){
      let searchParam = {
        pageNumber: this.page.current,
        pageSize: this.page.pageSize
      };
      this.$axios.fetchPost('' + "/page", searchParam)
        .then(data => {

        })
    },
  },
};
</script>

<style scoped>
.page-template{
  padding-top:0;
}
.page-template .centerBack {
  background: #fff;
  border-radius: 8px;
  padding: 25px;
}
.page-template .echartsArea {
  height: 270px;
  margin-bottom: 12px;
}
.activity-info{
  padding:10px;
}
.activity-name{
  display: inline-block;
  width:80px;
  font-size: 14px;
  line-height: 30px;
}
.activity-money{
  display: flex;
  height:40px;
  line-height: 40px;
  background-color: #f5f5f5;
  font-size: 16px;
  margin: 20px 0;
  padding:0 10px;
}

</style>



// WEBPACK FOOTER //
// src/page/activity/statistics.vue